import * as React from 'react';
import { clsx } from 'clsx';
import { UIHeading3 } from '@cian/ui-kit';

import * as styles from './SinglePhoneComponent.css';

export type TCallButtonSize = 'M' | 'XS';

interface ISinglePhoneComponentProps {
  phone: string;
  size: TCallButtonSize;
}

export const SinglePhoneComponent: React.FC<ISinglePhoneComponentProps> = ({ phone, size }) => (
  <div className={clsx(styles['phone'], styles[size === 'M' ? 'size-m' : 'size-xs'])}>
    <UIHeading3>{phone}</UIHeading3>
  </div>
);
